import { useAuthStore } from '@/stores/auth'
import use767AttachmentOverride from './use767AttachmentOverride'

export default async function (attachmentsList, serviceId) {
  const authStore = useAuthStore()

  const mapping = {
    767: use767AttachmentOverride
  }

  if (Object.keys(mapping).some((m) => m == serviceId)) {
    return await mapping[serviceId](attachmentsList)
  }

  console.info(`There's no draft override mapped for ${serviceId}`)
  return Promise.resolve(attachmentsList)
}
